import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import Reveal from "./Reveal";

const FAQ = [
  {
    q: "Quels formats de fichiers recevrai-je ?",
    a: "Selon votre besoin : .STL pour l'impression 3D, .STEP pour la CAO et l'usinage, .OBJ pour la visualisation. Les fichiers vous appartiennent, ils vous sont livrés à la validation finale.",
  },
  {
    q: "Que faire si ma pièce est brisée en plusieurs morceaux ?",
    a: "Aucun souci : photographiez chaque morceau sous plusieurs angles, avec une règle ou un mètre à côté. Nous recollons la pièce virtuellement et remodélisons les zones manquantes.",
  },
  {
    q: "Quels matériaux d'impression utilisez-vous ?",
    a: "PLA standard, PLA carbone pour la rigidité, et PETG pour les pièces exposées à la chaleur ou l'humidité. Six coloris de filament sont disponibles, dont l'orange signature de l'atelier.",
  },
  {
    q: "Comment se passe la validation et le paiement ?",
    a: "Après votre accord sur le devis, vous recevez un PDF avec un rendu 3D et/ou un plan pour valider le projet avant tout lancement. Une fois le projet accepté et le paiement réglé, le fichier .STL vous est envoyé (et, en option, la pièce imprimée). Pour les projets de plus de 50 €, un acompte de 30 % est demandé après acceptation du devis.",
  },
  {
    q: "Quels sont les délais habituels ?",
    a: "L'atelier ouvre en octobre 2026. Comptez un échange d'étude sous 48 h ouvrées, puis un délai de modélisation et d'impression précisé dans votre devis selon la complexité.",
  },
];

export default function FaqContactSection() {
  return (
    <section id="faq" className="scroll-mt-20 border-t border-black/5 py-24 lg:py-28">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-2 lg:px-12">
        <Reveal>
          <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-accent">FAQ</span>
          <h2 className="mt-3 font-display text-2xl font-extrabold tracking-tight text-ink sm:text-3xl lg:text-4xl">
            Les questions qu'on nous pose.
          </h2>
          <Accordion type="single" collapsible className="mt-8">
            {FAQ.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-black/10">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-5 text-left font-display text-base font-bold text-ink hover:text-accent hover:no-underline"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-neutral-600">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="corner-card relative flex h-full flex-col justify-between overflow-hidden rounded-[20px] border border-black/10 bg-mist p-8 sm:p-10">
            <div>
              <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-accent">Contact direct</span>
              <h3 className="mt-3 font-display text-xl font-bold tracking-tight text-ink sm:text-2xl">
                Une question avant de vous lancer ?
              </h3>
              <p className="mt-3 max-w-md text-sm leading-relaxed text-neutral-600">
                Écrivez-nous directement : nous revenons vers vous avec un avis de faisabilité et
                les prochaines étapes. Pour un chiffrage détaillé, décrivez votre projet dans le
                formulaire — c'est le chemin le plus rapide.
              </p>
            </div>
            <div className="mt-10">
              <a
                href="mailto:contact1@troideo.com"
                data-testid="faq-contact-email-link"
                className="font-mono text-sm font-medium text-ink underline decoration-accent decoration-2 underline-offset-4 transition-colors hover:text-accent"
              >
                contact@troideo.com
              </a>
              <div>
                <Link
                  to="/devis"
                  data-testid="faq-contact-cta-button"
                  className="group mt-6 inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3 text-sm font-semibold text-white transition-all hover:bg-accent"
                >
                  Aller au formulaire de devis
                  <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
